import React, { useCallback, useEffect } from 'react';
import { connect } from 'react-redux';
import { Avatar, Header, InfoLabel } from '@cubeyou-team/hx-react-components';
import styled from 'styled-components';
import { ProductsDropdown } from '@discover-frontend/components';

import { SSO_URLS } from '../../constants/config';
import { selectFilteredUserProducts } from '../../selectors/products';
import CollapsedHeader from './CollapsedHeader';
import { showModal, requestNotifications } from '../../actions';
import { getInitials } from '../../utils/misc';

const StyledNotificationLabel = styled.div`
  position: absolute;
  top: -5px;
  right: 0px;
`;

const logo = `${process.env.PUBLIC_URL}/logo-white.svg`;

const SSO_OVERVIEW_URL =
  process.env.REACT_APP_IS_LOCAL === 'true'
    ? SSO_URLS.localhost.REACT_APP_ID_SERVER_BASE
    : SSO_URLS[process.env.REACT_APP_API_ENV].REACT_APP_ID_SERVER_BASE;

const HeaderContainer = ({
  me,
  router,
  meProducts,
  shareQuery,
  size,
  showModal,
  requestNotifications,
}) => {
  const { data } = me;

  const isTransparent = router.location.pathname === '/logout';

  const meProductFiltered =
    !meProducts.isLoading && selectFilteredUserProducts(meProducts.data);
  const buttons =
    !meProducts.isLoading && meProductFiltered && meProductFiltered.length > 0
      ? [
          <ProductsDropdown
            dropdownPosition={size === 'default' ? 'right' : 'left'}
            products={meProductFiltered}
          />,
        ]
      : null;
  const notifications = (shareQuery && shareQuery.data) || [];
  const notificationsToRead = notifications.filter(
    notification => !notification.read
  ).length;

  useEffect(() => {
    requestNotifications('SHARE_QUERY');
    requestNotifications('SHARE_CUSTOM_TEMPLATE');
  }, [requestNotifications]);

  const handleUserMenuAction = useCallback(() => {
    showModal(
      {
        isOpen: true,
        position: 'right',
      },
      'UserPreview'
    );
  }, [showModal]);

  return size !== 'collapsed' ? (
    <Header
      logo={logo}
      user={data}
      isTransparent={isTransparent}
      backgroundColor="dark"
      size="full"
      style={{ boxShadow: 'rgb(173, 173, 173) 0px 1px 4px' }}
      buttons={buttons}
      baseRoute={`${SSO_OVERVIEW_URL}/`}
      logoWidth="140px"
    >
      {data.email && (
        <Avatar
          initials={getInitials(data.email, data.surname, data.name)}
          src={data.avatar}
          size="medium"
          onAvatarClick={() => handleUserMenuAction()}
          hoverEffect="standard"
        />
      )}
      {notificationsToRead > 0 && (
        <StyledNotificationLabel>
          <InfoLabel label={notificationsToRead} variant="error" />
        </StyledNotificationLabel>
      )}
    </Header>
  ) : (
    <CollapsedHeader user={data} />
  );
};

const mapDispatchToProps = {
  showModal,
  requestNotifications,
};

const mapStateToProps = state => ({
  me: state.me,
  router: state.router,
  meProducts: state.meProducts,
  shareQuery: state.shareQuery,
});

export default connect(mapStateToProps, mapDispatchToProps)(HeaderContainer);
